"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CloudDownloadFill = {
    name: 'cloud-download',
    theme: 'fill',
    nameWithTheme: 'cloud-download-fill',
    tag: 'svg',
    attrs: { xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 1024 1024' },
    children: [
        {
            tag: 'path',
            attrs: {
                d: 'M926.3 484.6v-.1l-1.3-2c-17.6-26.4-39.4-48.6-64.9-66.1-2-29.1-8.6-56.8-19.6-82.5-13.4-31.4-33.5-60.4-59.8-86-26-25.4-55.5-44.8-87.6-57.8-31.7-12.9-66.5-19.4-103.4-19.4-55.4 0-106.3 15.3-151.3 45.4-25.4 17-47.4 37.4-65.3 60.7-13.5-3.4-27.8-5.2-42.6-5.2-22.3 0-43.7 4-63.5 12-19.8 8-38 20-54.1 35.5-16.3 16-28.7 33.9-36.8 53.3-8.4 19.8-12.7 41.2-12.7 63.6 0 6.2.3 12.3 1 18.3-21.2 12.7-40 29.1-56.1 48.7-32.3 39-48.7 84.4-48.7 135 0 29.4 5.6 57.3 16.5 83.1 10.8 25.5 27.1 49 48.4 69.6 21.2 20.5 45 36.2 70.7 46.6 25.8 10.5 53.9 15.8 83.5 15.8h440.6c33 0 64.4-5.9 93.4-17.6 29-11.8 55.7-29.4 79.2-52.3 23.6-23 41.8-49.2 54-77.8 12.2-28.8 18.4-60 18.4-92.6.1-46.2-12.7-89.4-38-128.2zM751.1 602.1L621.5 731.7c-6.8 6.8-15.8 10.5-25.3 10.5s-18.6-3.7-25.3-10.5L441.3 602.1c-14-14-14-36.7 0-50.6 6.8-6.8 15.7-10.5 25.3-10.5 9.5 0 18.5 3.7 25.3 10.5l68.6 68.5V373.6c0-19.7 16-35.8 35.8-35.8 19.7 0 35.8 16.1 35.8 35.9V620l68.5-68.5c6.8-6.8 15.7-10.5 25.3-10.5s18.5 3.7 25.3 10.5c13.9 13.9 13.9 36.6-.1 50.6z'
            },
            children: []
        }
    ]
};
exports.default = CloudDownloadFill;



//////////////////
// WEBPACK FOOTER
// /Users/jim/Documents/GitHub/chenshuai/ant-design-pro-site/scaffold/node_modules/@ant-design/icons/lib/fill/CloudDownloadFill.js
// module id = 555
// module chunks = 0